module.exports = __webpack_public_path__ + "img/138.0cb7fe89.jpg";